<script lang="ts" setup>
import type { IYarisma } from '@/model/yarisma'
import type { IYarismaKalansure } from '@/model/yarisma'
import { useRouter } from 'vue-router'

interface Props {
  yarisma?: IYarisma | null
  yarismaKalansure: IYarismaKalansure | null
  baslamasinaKalanSure: number
}

defineProps<Props>()
const router = useRouter()
</script>

<template>
  <div
    class="card w-full p-3 md:p-6 space-y-2 flex flex-col items-center justify-center px-4 md:px-6"
  >
    <h2 class="text-title-md text-gray-800">{{ yarisma?.isim }}</h2>
    <div class="flex items-center justify-center gap-3 text-body-md text-gray-400">
      <div class="inline-flex items-center gap-2 rounded-full px-1 md:px-3 py-2">
        <MIcon name="alarm" size="20px" class="text-gray-400" />
        <span>{{ yarismaKalansure?.baslangic_saati }}</span>
      </div>
      <span class="hidden h-6 w-px bg-gray-100 md:block" aria-hidden="true"></span>
      <div class="inline-flex items-center gap-2 rounded-full px-1 md:px-3 py-2">
        <MIcon name="hourglass_top" size="20px" class="text-gray-400" />
        <span>{{ $t('yarisma_info.duration') }} {{ yarisma?.sure }} {{ $t('yarisma_info.minutes') }}</span>
      </div>
      <span class="hidden h-6 w-px bg-gray-100 md:block" aria-hidden="true"></span>
      <div class="inline-flex items-center gap-2 rounded-full px-1 md:px-3 py-2">
        <MIcon name="help" size="20px" class="text-gray-400" />
        <span> {{ yarisma?.soru_sayisi }} {{ $t('yarisma_info.questions') }}</span>
      </div>
    </div>

    <div v-if="baslamasinaKalanSure === 0" class="mt-10 w-full md:w-auto">
      <button
        type="button"
        class="btn btn-primary w-full md:w-auto"
        @click="router.push('/yarisma')"
      >
        {{ $t('yarisma_info.enter_exam') }}
      </button>
    </div>
  </div>
</template>
